import React, { useEffect, useState, useRef } from 'react';
import './TauriSidebar.css';
import TauriApplicationSelection from '../TauriApplicationSelection/TauriApplicationSelection';
import TauriSidebarItem from '../TauriSidebarItem/TauriSidebarItem';
import config from '../../appURL.json';
import setting from '../../config.json';
import { getDataByEndPoint, getData } from '../../visualizations/visualizations';
import { FactoryComponent } from '../../visualizations/FactoryComponent';
import { useNavigate } from 'react-router-dom';

const TauriSidebar = ({ onHeaderClick, handleItemClick }) => {

    const [menuList, setMenuList] = useState([]);
    const [sidebarItemList, setSidebarItemList] = useState([]);
    const [parentList, setParentList] = useState([]);
    const [access, setAccess] = useState(null);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const navigate = useNavigate()

    const [colorRange, setColorRange] = useState([]);

    const customHeaderDropdownStyle = {
        backgroundColor: colorRange[0],
        boxShadow: '0 0.25rem 0.375rem rgba(0, 0, 0, 0.1)',
    };
    const customSubmenuStyle = {
        width: '18.75rem',
        backgroundColor: colorRange[0],
        boxShadow: '0 0.25rem 0.375rem rgba(0, 0, 0, 0.1)',
    };

    const customButtonIconStyle = {
        width: '1.25rem',
        height: '1.25rem',
        marginLeft: '1.25rem',
        filter: 'invert(32%) sepia(30%) saturate(1325%) hue-rotate(167deg) brightness(94%) contrast(93%)',
    };

    const customSubmenuIconStyle = {
        width: '1.25rem',
        height: '1.25rem',
        filter: 'invert(32%) sepia(30%) saturate(1325%) hue-rotate(167deg) brightness(94%) contrast(93%)',
    }

    const fetchMenuList = async () => {
        try {
            const response = await fetch(`${config.API_BaseUrl}/application`);
            const items = await response.json();
            setMenuList(items.applications);
            setParentList(items.applications[0].modules[0]);

        } catch (error) {
            console.error('Error decoding items:', error);
        }
    };

    const fetchSidebarItemList = async (parentID) => {
        try {
            if (!parentID) {
                parentID = 1;
            }
            const response = await fetch(`${config.API_BaseUrl}/applicationItem/${parentID}`);
            const items = await response.json();

            setSidebarItemList(items);


        } catch (error) {
            console.error('Error decoding items:', error);
        }
    };

    const handleItemSelected = (parent, child) => {
        if (parent, child) {
            fetchSidebarItemList(parent.id);
            handleItemClick(parent, child.name);
            setParentList(parent);
        }
    };

    const handleHeaderClicked = (parent) => {
        if (parent) {
            onHeaderClick(parent);
            fetchSidebarItemList(parent.id);
            setParentList(parent);
        }
    }

    const onSidebarItemSelected = (parent, childPath) => {
        handleItemClick(parent, childPath);
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const filterApplicationItemsByRoleLevel = (items, access) => {
        return items.filter(item => {
            if (!item.roleLevel || parseInt(item.roleLevel, 10) < access) {
                if (item.children && item.children.length > 0) {
                    item.children = filterApplicationItemsByRoleLevel(item.children, access);
                }
                return true;
            }
            return false;
        });
    };

    const filterSidebarItemsByRoleLevel = (itemList, access) => {
        return itemList.filter(item => {
            return parseInt(item.roleLevel, 10) < access;
        });
    };

    useEffect(() => {
        const getUserData = localStorage.getItem('UserData');
        const decodedUserData = JSON.parse(atob(getUserData));

        const userPermission = decodedUserData?.UserPermission?.Data?.Children?.find(child => child.Name === 'DataScope').Children;
        const access = userPermission.find(item => item.CompanyId == setting.CompanyId)?.Access;

        const applicationData = FactoryComponent('application', access ? access.toString() : '-1');
        const filteredModules = applicationData.applications.map(app => ({
            ...app,
            modules: app.modules.map(module => ({
                ...module,
                children: filterApplicationItemsByRoleLevel(module.children, access || []) // Filter each module's children
            }))
        }));

        setMenuList(filteredModules);
        setParentList(filteredModules[0].modules[0]);

        const colorsheme = FactoryComponent('colorScheme','-1');

        const themeId = colorsheme.themes.find(theme => theme.id = "colorTheme1")?.sidebar?.ranges;
        const matchingRanges = colorsheme.palettes
            .filter(palette => themeId.includes(palette.id))
            .map(palette => ({ id: palette.id, ranges: palette.ranges }));
        setColorRange(matchingRanges[0]?.ranges);

        const applicationItemData = getDataByEndPoint("applicationItem");

        setAccess(access);

        if (!access) {
            const defaultPath = `dashboards/1`;
            navigate(defaultPath, { replace: true });
        }

        const filteredData = applicationItemData.data.find(item => item.parentID === 1).item.map(item => ({
            ...item,
            itemList: filterSidebarItemsByRoleLevel(item.itemList, access) // Filter the itemList based on access
        }));

        const filteredDataWithItems = filteredData.filter(item => item.itemList && item.itemList.length > 0);
        setSidebarItemList(filteredDataWithItems);
    }, []);

    return (
        <div className='sidebar-container'>
            {access && (
                <>
                    <div className="dropdown-multilevel d-none d-xl-block">
                        <TauriApplicationSelection
                            menuList={menuList}
                            headerStyle={customHeaderDropdownStyle}
                            submenuStyle={customSubmenuStyle}
                            buttonIconStyle={customButtonIconStyle}
                            submenuIconStyle={customSubmenuIconStyle}
                            onItemSelected={handleItemSelected}
                            onHeaderClick={handleHeaderClicked}
                        />
                    </div>
                    <div className="sidebar-item h-100">
                        <TauriSidebarItem
                            parentlist={parentList}
                            itemlist={sidebarItemList}
                            onSidebarItemSelected={onSidebarItemSelected}
                        />
                    </div>
                </>
            )}
        </div>

    );
};

export default TauriSidebar;
